/** Tolerancia alineada con el API (`AfipComprobanteRescateService`). */
const TOLERANCIA_IMPORTE = 0.01;

export function parseImporteAfip(valor?: string | number | null): number | null {
  if (valor == null || valor === '') return null;
  if (typeof valor === 'number') {
    return Number.isFinite(valor) ? valor : null;
  }
  const s = String(valor).trim();
  if (!s) return null;
  const n = Number(s.replace(',', '.'));
  return Number.isFinite(n) ? n : null;
}

function round2(n: number): number {
  return Math.round((n + Number.EPSILON) * 100) / 100;
}

/** Compara importes ARCA (string) vs eOne (number) redondeados a 2 decimales. */
export function importesCoinciden(
  a?: string | number | null,
  b?: string | number | null
): boolean | null {
  const na = parseImporteAfip(a);
  const nb = parseImporteAfip(b);
  if (na == null && nb == null) return null;
  if (na == null || nb == null) return null;
  return Math.abs(round2(na) - round2(nb)) <= TOLERANCIA_IMPORTE;
}
